/*
 *
 * OnDemandSettlements actions
 *
 */

import {
  DEFAULT_ACTION,
  GET_ON_DEMAND_SETTLEMENT_STATUS,
  GET_SETTLEMENT_RATES,
  GET_ON_DEMAND_MAX_DAILY_LIMIT,
  ENABLE_LOADER,
  DISABLE_LOADER,
  CREATE_ON_DEMAND_SETTLEMENTS,
  GET_ELIGIBLE_FUNDS,
  UPDATE_ELIGIBLE_FUNDS,
  GET_SETTLEMENT_HOLIDAYS,
  UPDATE_SETTLEMENT_HOLIDAYS,
  GET_UNSETTLED_AMOUNT,
  UPDATE_UNSETTLED_AMOUNT,
  REQUEST_ON_DEMAND_ACTIVATION,
  RESET_DATA,
  RESET_PAGE,
  UPDATE_FILTERS,
  UPDATE_TABLE_DATA,
  SEARCH_SETTLEMENTS,
  SAVE_SETTLEMENTS,
  RESET_FILTERS,
  UPDATE_FREE_TRIAL_STATUS,
  EXTEND_FREE_TRIAL,
  GET_FREE_TRIAL_NUDGE,
  GET_FREE_TRIAL_STATUS,
  GET_ON_DEMAND_SETTLE_NOW_DATA,
  GET_FREE_TRIAL_CONSTANTS,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function getOnDemandSettlementStatusAction(data) {
  return {
    type: GET_ON_DEMAND_SETTLEMENT_STATUS,
    data,
  };
}

export function getSettlementRatesAction(data) {
  return {
    type: GET_SETTLEMENT_RATES,
    data,
  };
}

export function getOnDemandMaxDailyLimitAction(data) {
  return {
    type: GET_ON_DEMAND_MAX_DAILY_LIMIT,
    data,
  };
}

export function createOnDemandSettlementsAction(data) {
  return {
    type: CREATE_ON_DEMAND_SETTLEMENTS,
    data,
  };
}

export function getEligibleFundsAction(data) {
  return {
    type: GET_ELIGIBLE_FUNDS,
    data,
  };
}

export function updateEligibleFunds(data) {
  return {
    type: UPDATE_ELIGIBLE_FUNDS,
    data,
  };
}

export function getSettlementsHolidaysAction(data) {
  return {
    type: GET_SETTLEMENT_HOLIDAYS,
    data,
  };
}

export function saveSettlementsHolidaysAction(data) {
  return {
    type: UPDATE_SETTLEMENT_HOLIDAYS,
    data,
  };
}

export function getUnsettledAmountAction(data) {
  return {
    type: GET_UNSETTLED_AMOUNT,
    data,
  };
}

export function updateUnsettledAmount(data) {
  return {
    type: UPDATE_UNSETTLED_AMOUNT,
    data,
  };
}

export function requestOnDemandActivationAction(data) {
  return {
    type: REQUEST_ON_DEMAND_ACTIVATION,
    data,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}

export function resetPageAction(data) {
  return {
    type: RESET_PAGE,
    data,
  };
}

export function resetFiltersAction(data) {
  return {
    type: RESET_FILTERS,
    data,
  };
}

export function updateTableDataAction(data) {
  return {
    type: UPDATE_TABLE_DATA,
    data,
  };
}

export function updateFiltersAction(data) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function searchSettlementsAction(data) {
  return {
    type: SEARCH_SETTLEMENTS,
    data,
  };
}

export function saveSettlementsAction(data) {
  return {
    type: SAVE_SETTLEMENTS,
    payload: data,
  };
}

export function updateFreeTrialStatusAction(data) {
  return {
    type: UPDATE_FREE_TRIAL_STATUS,
    data,
  };
}

export function extendFreeTrialAction(data) {
  return {
    type: EXTEND_FREE_TRIAL,
    data,
  };
}

export function getFreeTrialNudgeAction(data) {
  return {
    type: GET_FREE_TRIAL_NUDGE,
    data,
  };
}

export function getFreeTrialStatusAction(data) {
  return {
    type: GET_FREE_TRIAL_STATUS,
    data,
  };
}

export function getOnDemandSettleNowDataAction(data) {
  return {
    type: GET_ON_DEMAND_SETTLE_NOW_DATA,
    data,
  };
}

export function getFreeTrialConstantsAction(data) {
  return {
    type: GET_FREE_TRIAL_CONSTANTS,
    data,
  };
}
